export default "__VITE_ASSET__Cx08MOmu__"